import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function GuideSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-charcoal-dark border-t border-white/5" data-id="element-120">
      <div className="max-w-3xl mx-auto" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-charcoal border border-gold/30 rounded-3xl p-8 sm:p-10 relative overflow-hidden" data-id="element-122">
          <div className="absolute top-0 right-0 w-48 h-48 bg-gold/10 blur-[60px] rounded-full pointer-events-none" data-id="element-123" />

          <div className="flex flex-col sm:flex-row gap-8 items-center sm:items-start relative z-10" data-id="element-124">
            <div className="flex-shrink-0" data-id="element-125">
              <div className="w-28 h-28 rounded-full border-4 border-gold/30 overflow-hidden shadow-lg" data-id="element-126">
                <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80&auto=format&fit=crop" alt="Catalina" className="w-full h-full object-cover" data-id="element-127" />
              </div>
            </div>

            <div className="text-center sm:text-left" data-id="element-128">
              <h3 className="text-2xl font-bold mb-1" data-id="element-129">¿Quién te guía?</h3>
              <p className="text-cream-muted leading-relaxed mb-5" data-id="element-130">
                Soy Catalina. Empecé vendiendo focaccias en mi barrio sin
                experiencia, sin local y sin inversión grande. En menos de dos
                años construí un método que ya ayudó a más de 200 mujeres en
                toda Argentina a generar sus primeros ingresos reales desde la
                cocina de su casa.
              </p>
              <ul className="flex flex-col sm:flex-row gap-3 sm:gap-5" data-id="element-131">
                {['+200 alumnas', 'Método probado', 'Resultados reales'].map((item, i) => <li key={i} className="flex items-center gap-2 text-gold-light font-medium text-sm" data-id="element-132">
                      <CheckCircle2 className="w-4 h-4 text-gold" data-id="element-133" />
                      {item}
                    </li>)}
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}